import { useShowNotification, useSocket } from '@elotech/components';
import { AxiosRequestConfig } from 'axios';
import { useCallback, useEffect } from 'react';

const getAsyncNotificationId = () => {
  const SESSION_ID_KEY = 'ASYNC_NOTIFICATION_SESSION_ID';
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY);

  if (!sessionId) {
    const dateId = Date.now().toString(36);
    const randomId = Math.random().toString(36).substring(2);

    sessionId = `oxy-adm-${dateId}-${randomId}`;
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  return sessionId;
};

export const configureAxiosForAsyncNotification = (
  config: AxiosRequestConfig
) => {
  const sessionId = getAsyncNotificationId();
  const headers = config.headers || {};
  headers['Elo-Session-Id'] = sessionId;
  config.headers = headers;
};

export const AsyncNotification = () => {
  const socket = useSocket();
  const showNotification = useShowNotification();

  const handleNotification = useCallback(
    message => {
      try {
        const args = JSON.parse(message?.[0]);
        if (args) {
          showNotification(args);
        }
      } catch (e) {
        showNotification({
          level: 'error',
          message
        });
      }
    },
    [showNotification]
  );

  useEffect(() => {
    const sessionId = getAsyncNotificationId();
    if (!socket || !sessionId) {
      return;
    }
    const name = `async-notification-${sessionId}`;

    socket.on(name, handleNotification);
    return () => {
      socket.off(name, handleNotification);
    };
  }, [socket, handleNotification]);

  return null;
};
